import { Directive, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { asyncScheduler, fromEvent } from 'rxjs';

import { InputComponent } from './input.component';
import { Platform } from '@angular/cdk/platform';

@Directive({ selector: '[appInputFocus]' })
export class InputFocusDirective implements OnInit {
  @Input()
  appInputFocusOnlyIfFits = false;

  constructor(
    private input: InputComponent,
    private platform: Platform,
  ) {
    fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        if (event.key === 'Enter') {
          this.input.blur();
        }
      });
  }

  ngOnInit(): void {
    if(this.platform.IOS) {
      return;
    }
    asyncScheduler.schedule(() => {
      if (!this.appInputFocusOnlyIfFits || this.fitsViewport()) {
        this.input.focus();
      }
    }, 100);
  }

  private fitsViewport(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    const rect = this.input.inputRef.nativeElement.getBoundingClientRect();

    return rect.top >= 0
      && rect.left >= 0
      && rect.bottom <= window.innerHeight
      && rect.right <= window.innerWidth;
  }
}
